import { OnInit, OnDestroy } from '@angular/core';
import { INodeOptions } from "@app/workflow-common/diagram-view2/models/node.model";
import { Subject } from "rxjs";
import { DiagramService } from "@app/workflow-common/diagram-view2/services/diagram.service";
import { DagSourceModel } from "@app/workflow-common/services/DagSourceModel";
var NodeViewComponent = /** @class */ (function () {
    function NodeViewComponent(_diagramService) {
        this._diagramService = _diagramService;
        this.hasParent = false;
        this.direction = 'vertical';
        this.isNew = false;
        this.index = undefined;
        this._unsubscribeAll = new Subject();
    }
    NodeViewComponent.prototype.ngOnInit = function () {
        this._diagramService.setParams({
            nodeOptions: this.nodeOptions,
        });
    };
    Object.defineProperty(NodeViewComponent.prototype, "hostClass", {
        get: function () {
            return this.direction === 'vertical' ? 'column' : '';
        },
        enumerable: true,
        configurable: true
    });
    NodeViewComponent.prototype.ngOnDestroy = function () {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    };
    return NodeViewComponent;
}());
export { NodeViewComponent };
